export const USE_LOCAL_EXTENSION = 'USE_LOCAL_EXTENSION';

export const modalMessages = {
  title: 'Get the Distribute Chrome Extension',
  description:
    'The fastest follow-up tool for sales. Cut your follow-up time by 10x.',
  items: [
    {
      id: 1,
      text: 'Create speedy recordings for your pages and import existing content effortlessly.',
      image: '../../../assets/images/extension-banner-1.png',
      isComingSoon: false,
    },
    {
      id: 2,
      text: 'Share a direct recording link or create a follow-up page directly from Gmail or LinkedIn.',
      image: '../../../assets/images/extension-banner-2.png',
      isComingSoon: false,
    },
    {
      id: 3,
      text: 'Easily import any text materials directly into the page with just a single click',
      image: '../../../assets/images/extension-banner-3.png',
      isComingSoon: true,
    },
  ],
} as const;

export const onboardingMessages = {
  title: 'Get Chrome extension',
  description:
    'Create speedy recordings for your pages and import existing content effortlessly.',
  items: [
    { id: 1, text: 'It’s fully free' },
    { id: 2, text: 'Record over any window' },
    { id: 3, text: 'Import your existing content to Distribute' },
  ],
} as const;
